import { APIMain } from "@/apiRequester";
import { AppOptionType, ISysTableItem } from "@/models";

export const deleteSysTable = (url: string) => {
  let baseUrl = undefined;
  if (url.includes("api/category")) baseUrl = "";
  return APIMain.delete<boolean>(`${url}`, undefined, undefined, {
    baseUrl,
  });
};
// update
export const patchSysTableStatus = (urlPatchStatus: string) => {
  return APIMain.patch<boolean>(urlPatchStatus);
};
export const getSysTableById = <T extends {}>(
  id: string,
  apiUrlGetDetailUpdate: string,
) => {
  let baseUrl = undefined;
  if (apiUrlGetDetailUpdate.includes("api/category")) baseUrl = "";
  return APIMain.get<T>(`${apiUrlGetDetailUpdate}/${id}`, undefined, {
    baseUrl,
  });
};
export const getListSysTable = (
  request: object,
  urlApiList: string,
  controller?: AbortController,
  accessToken?: string,
) => {
  let baseUrl = undefined;
  if (urlApiList.includes("api/category")) baseUrl = "";
  return APIMain.getPaging<ISysTableItem>(urlApiList, request, {
    accessToken,
    controller,
    baseUrl,
  });
};
export const getSysTableTotal = (
  request: object,
  apiUrlGetTotal: string,
  controller?: AbortController,
  accessToken?: string,
) => {
  return APIMain.get<number>(apiUrlGetTotal, request, {
    accessToken,
    controller,
    baseUrl: "",
  });
};
// create lectures
export const postSysTable = (request: object, apiUrlCreate: string) => {
  let baseUrl = undefined;
  if (apiUrlCreate.includes("api/category")) baseUrl = "";
  return APIMain.post<boolean>(apiUrlCreate, request, {
    baseUrl,
  });
};
export const postReturnIdSysTable = (request: object, apiUrlCreate: string) => {
  let baseUrl = undefined;
  if (apiUrlCreate.includes("api/category")) baseUrl = "";
  return APIMain.post<string>(apiUrlCreate, request, {
    baseUrl,
  });
};
// update
export const putSysTable = (request: object, apiUrlUpdate: string) => {
  let baseUrl = undefined;
  if (apiUrlUpdate.includes("api/category")) baseUrl = "";
  return APIMain.put<boolean>(apiUrlUpdate, request, {
    baseUrl,
  });
};
export const patchSysTable = (request: object, apiUrl: string) => {
  let baseUrl = undefined;
  if (apiUrl.includes("api/category")) baseUrl = "";
  return APIMain.patch<boolean>(apiUrl, request, {
    baseUrl,
  });
};
export const getOptionsSelect = async () => {
  return await new Promise<AppOptionType[]>((resolve) => {
    // Sử dụng setTimeout để trì hoãn việc gọi hàm resolve trong 1000ms
    setTimeout(() => {
      const data: AppOptionType[] = [
        {
          value: 1,
          label: "test 1",
        },
        {
          value: 2,
          label: "test 2",
        },
        {
          value: 3,
          label: "test 3",
        },
      ];
      // Gọi hàm resolve với dữ liệu đã được chuẩn bị sau khi đã trì hoãn
      resolve(data);
    }, 2000);
  });
};
